import moment from 'moment';
import fields from './fields.utils.js';


const schema_boat = {
    ...fields.notes,
    //source
    'source_uuid': {
        type: 'select',
        label: 'source',
        value: '',
        options: [],
        required: true
    },
    'first_name': {
        label: 'First Name',
        placeholder: 'First Name',
        type: 'text',
        value: '',
        required: true,

    },
    'last_name': {
        label: 'Last Name',
        placeholder: 'Last Name',
        type: 'text',
        value: '',
        required: true,

    },
    'postcode': {
        label: 'Postal Code',
        placeholder: 'Postal Code',
        type: 'address-lookup',
        value: '',
        required: true,

    },
    'address1': {
        label: 'Address Line 1',
        placeholder: 'Address Line 1',
        value: '',
        type: 'text',
        required: true,


    },
    'address2': {
        label: 'Address Line 2',
        placeholder: 'Address Line 2',
        value: '',
        type: 'text',

    },
    'address3': {
        label: 'Address Line 3',
        placeholder: 'Address Line 3',
        type: 'text',
        value: '',

    },
    'address4': {
        label: 'Address Line 4',
        placeholder: 'Address Line 4',
        type: 'text',
        value: '',

    },
    'city': {
        label: 'City',
        placeholder: 'City',
        type: 'text',
        value: '',
        required: true,

    },
    'date_of_birth': {
        label: 'Date of birth',
        type: 'date-mask',
        value: '',
        required: true,

        placeholder: 'Date of Birth'
    },
    'telephone': {
        label: 'Telephone',
        placeholder: 'Telephone',
        type: 'text',
        value: '',
        required: true,

    },
    'email': {
        label: 'Email Address',
        placeholder: 'Email Address',
        type: 'email',
        value: '',
    },
    'craft_type': {
        label: 'Type of craft',
        type: 'select',
        value: '',
        options: [],
        required: true
    },

    'boat_material': {
        label: 'What Material is the boat made from?',
        type: 'select',
        value: '',
        options: [],
        required: true
    },

    'year': {
        label: 'Year',
        type: 'number',
        required: true,
        value: '',

        placeholder: 'Year'
    },
    'value': {
        label: 'Craft Value',
        type: 'number',
        value: 1,
        required: true,

        placeholder: 'Vehicle Value'
    },
    'kept_ashore': {
        label: 'Is the craft kapt ashore?',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true
    },
    'years_experience': {
        label: 'How many years experience do you have with this craft?',
        type: 'number',
        value: 1,
        required: true,

        placeholder: 'Vehicle Value'
    },
    'claims_or_accidents': {
        label: 'Any Accidents or Claims in relation to Boat Insurance?',
        type: 'bool',
        value: false,
        options: [{key: false, value: 'no'}, {key: true, value: 'yes'}],
        required: true
    },
    'ncb_years_boat': {
        label: 'Ncb Years',
        type: 'number',
        value: 0,
        required: true,

        placeholder: 'Ncb Years'
    },
    'cover_date': {
        label: 'Cover Date',
        type: 'date-picker',
        value: moment().format('DD/MM/YYYY'),
        required: true,

        placeholder: 'Cover Date'
    },
    ...fields.marketing,
    ...fields.cross_selling,
    ...fields.title,
};
export default schema_boat;
